/* eslint-disable @next/next/no-img-element -- two stacked marks that cross-fade; next/image would fight the transition */
import { cn } from "@/lib/utils";

/**
 * A product's mark beside its name, sized to sit where the Quikit wordmark sits in the bar.
 *
 * The name is live text rather than part of the artwork: the logo library still carries a
 * few old names (QuikLMS, QuikPresentation, QuikSign), and setting it in the site's own
 * font means a product can never show a name the catalogue has moved on from.
 *
 * Both tone variants are rendered and cross-faded, so the lockup inverts with the bar
 * instead of swapping in a half-loaded image as a dark panel passes under it.
 */
export function ProductLockup({
  slug,
  name,
  dark,
  className,
}: {
  slug: string;
  name: string;
  dark?: boolean;
  className?: string;
}) {
  return (
    <span className={cn("flex items-center gap-2", className)}>
      <span className="relative block size-[30px] shrink-0">
        {(["light", "dark"] as const).map((tone) => (
          <img
            key={tone}
            src={`/logos/${slug}-${tone}.svg`}
            alt=""
            width={30}
            height={30}
            className={cn(
              "absolute inset-0 size-full transition-opacity duration-500 ease-[var(--ease-premium)]",
              (tone === "dark") === !!dark ? "opacity-100" : "opacity-0",
            )}
          />
        ))}
      </span>
      <span className="text-[18px] font-medium leading-none tracking-[-0.035em]">{name}</span>
    </span>
  );
}
